import { Component, OnInit, PACKAGE_ROOT_URL, ViewChild } from '@angular/core';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { TreeModule, TreeNode, LazyLoadEvent, ConfirmationService, TabPanel } from 'primeng';
import { MenuService } from '../../services/menu.service';
import { OrganisationsService } from '../../services/organisations.service';
import { BBWTMessageService } from '../../services/message.service';
import { Location } from '@angular/common';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';

@Component({
  selector: 'postcodes',
  templateUrl: './manage-postcodes.component.html',
  providers: [OrganisationsService],
})
export class PostcodesComponent implements OnInit {
  public res: TreeNode[] = [];
  public org_id: number;
  public isLoaded: boolean = false;
  public orgnodes: any = [];
  public selectednodeid: any;
  public selectedNode: any;
  public currentnodetype: any;
  public ukcodes: string[];
  public londoncodes: string[];

  public backTo: string;
  public isBusy = false;

  @ViewChild('tabUKPostcodes') tabUKPostcodes: TabPanel;
  @ViewChild('tabLondonPostcodes') tabLondonPostcodes: TabPanel;

  constructor(
    private orgService: OrganisationsService,
    private router: Router,
    public messageService: BBWTMessageService,
    private route: ActivatedRoute,
    public menuService: MenuService,
    private location: Location,
    private confirmationService: ConfirmationService,
    private primeMessageService: MessageService,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.orgService.getpostcodesstructure().then((result) => {
      //console.log("Postcode structure: ", result);

      this.orgnodes = result.length > 0 ? result[0].children : [];

      //Remove Nodes from Customer User
      this.orgnodes = this.orgnodes.filter((org) => org.data.nodeType != 'Department');

      if (result[0].children.length > 0) {
        this.selectednodeid = result[0].children[0].data.nodeId;
        this.currentnodetype = result[0].children[0].data.nodeType;
      }

      let selectedRootNode: any = result[0];
      this.isLoaded = true;
      this.selectedNode = this.orgnodes[0];

      if (this.selectednodeid != null && this.selectednodeid != undefined) {
        this.loadRegion(this.selectednodeid);

        if (result[0].children[0].children.length > 0) {
          let depot = result[0].children[0].children[0].data;
          let depotId = depot.nodeId;
          this.selectednodeid = depotId;
          this.currentnodetype = depot.nodeType;
          this.loadDepot(depotId);
        }
      }

      console.log(this.orgnodes);
    });
  }

  onLondonCodeChange(codesArray) {
    //console.log("LONDON Codes in manage: ", codesArray);
    this.londoncodes = codesArray;
  }

  onUKCodeChange(codesArray) {
    //console.log("UK Codes in manage: ", codesArray);
    this.ukcodes = codesArray;
  }

  save() {
    let noUK = this.ukcodes.length == 0;
    let noLondon = this.londoncodes.length == 0;

    let msg = '';
    if (noUK) {
      msg = 'There are currently no UK Postcodes selected, do you want to continue saving?';
    } else if (noLondon) {
      msg = 'There are currently no London Postcodes selected, do you want to continue saving?';
    }

    // error if nothing selected in either area
    if (noUK && noLondon) {
      this.primeMessageService.add(
        Message.Error('At least one area in either UK or London region must be selected.', 'Error'),
      );
      return;
    }

    if (noUK || noLondon) {
      //console.log("Confirmation warning");

      this.confirmationService.confirm({
        message: msg,
        header: 'Save Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Save Anyway',
        rejectLabel: 'Cancel',
        accept: () => {
          this.doSave();
        },
        reject: () => {},
      });
    } else {
      this.doSave();
    }
  }

  async doSave() {
    this.isBusy = true;

    console.log(this.currentnodetype);
    var postcodes: any[] = [];
    this.ukcodes.forEach((o) => postcodes.push({ postcode: o, isLondon: false }));
    this.londoncodes.forEach((o) => postcodes.push({ postcode: o, isLondon: true }));

    //console.log("Uk Postcodes: ", this.ukcodes);
    //console.log("London postcodes: ", this.londoncodes);

    if (this.currentnodetype == 'Region') {
      //console.log("Updating region postcodes: ", postcodes);
      await this.orgService.updateRegionPostcodes(this.selectednodeid, postcodes);
    } else if (this.currentnodetype == 'Depot') {
      //console.log("Updating depot postcodes: ", postcodes);
      await this.orgService.updateDepotPostcodes(this.selectednodeid, postcodes);
    }

    this.isBusy = false;
  }

  loadRegion(id: number) {
    this.orgService.getregionpostcodes(id).then((result) => {
      this.londoncodes = [];
      this.ukcodes = [];
      result.forEach((o) => {
        if (o.isLondon) {
          this.londoncodes.push(o.postcode);
        } else {
          this.ukcodes.push(o.postcode);
        }
      });
    });
  }

  loadDepot(id: number) {
    this.orgService.getdepotpostcodes(id).then((result) => {
      this.londoncodes = [];
      this.ukcodes = [];
      result.forEach((o) => {
        if (o.isLondon) {
          this.londoncodes.push(o.postcode);
        } else {
          this.ukcodes.push(o.postcode);
        }
      });
    });
  }

  nodeSelect(event) {
    //console.log("Tree event: ", event);

    this.selectednodeid = event.node.data.nodeId;
    this.currentnodetype = event.node.data.nodeType;
    switch (event.node.data.nodeType) {
      case 'Region': {
        this.loadRegion(event.node.data.nodeId);
        break;
      }
      case 'Depot': {
        this.loadDepot(event.node.data.nodeId);
        break;
      }
    }

    this.currentnodetype = event.node.data.nodeType;
  }

  close() {
    if (this.backTo) this.router.navigate([this.backTo]);
    else this.router.navigate(['/']);
  }
}
